import styled, { css } from "styled-components";
import { Flex } from "rebass/styled-components";
import { RiComputerLine } from "react-icons/ri";
import { MdPhoneAndroid } from "react-icons/md";
import { SiDiscord } from "react-icons/si";

import { Subheader } from "../Text";
import { Link } from "../Button";
import { Tooltip } from "../Tooltip";

const iconStyle = css`
  margin-right: 10px;
  align-self: center;
  color: ${(props) => props.theme.colors.envy};
`;

export const StyledComputer = styled(RiComputerLine)`
  ${iconStyle}
`;

export const StyledMobile = styled(MdPhoneAndroid)`
  ${iconStyle}
`;

export const StyledDiscord = styled(SiDiscord)`
  ${iconStyle}
`;

export const DropdownContainer = styled(Tooltip)`
  &:hover {
    cursor: default;
  }
`;

export const AppContainer = styled(Subheader)`
  align-items: center;
  background-color: ${(props) => props.theme.colors.navy};
  border: 1px solid ${(props) => props.theme.colors.chalkAlpha20};
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  color: ${(props) => props.theme.colors.ice};
  cursor: pointer;
  display: flex;
  font-weight: 600;
  height: 34px;
  justify-content: center;
  min-width: 90px;
  padding: 0 16px;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${(props) => props.theme.colors.envy};
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const AppDropdown = styled(Flex)`
  flex-direction: column;
  color: ${(props) => props.theme.colors.ice};
  white-space: nowrap;
`;

export const StyledButtonContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  text-align: left;
  min-width: 75px;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  align-self: center;
  height: 35px;
  border-radius: 8px;
  padding-left: 10px;
  padding-right: 10px;

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.midnightAlpha50};
    color: ${(props) => props.theme.colors.envy};
  }
`;

export const DropdownTopSection = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
